import React from 'react';

import { Bookmark } from '@/domains';

export interface State {
  value?: Bookmark[];
  loading: boolean;
  error?: Error;
}

export type Actions =
  | { type: 'success'; value: Bookmark[] }
  | { type: 'error'; error: Error }
  | { type: 'insert-ordered-by-location'; bookmark: Bookmark }
  | { type: 'delete-by-ids'; ids: string[] };

export const reducer: React.Reducer<State, Actions> = (state, action) => {
  switch (action.type) {
    case 'success':
      return { value: action.value, loading: false };
    case 'error':
      return { loading: false, error: action.error };
    case 'insert-ordered-by-location': {
      if (!state.value) return { ...state, value: [action.bookmark] };

      return {
        ...state,
        value: [...state.value, action.bookmark].sort((one, other) =>
          one.sortingLocation.localeCompare(other.sortingLocation)
        )
      };
    }
    case 'delete-by-ids': {
      if (!state.value) return state;

      return {
        ...state,
        value: state.value.filter((bookmark) => !action.ids.includes(bookmark.id))
      };
    }
  }
};
